import { Box, Breadcrumbs, ImageList, ImageListItem, ImageListItemBar, Typography } from "@mui/material";
import Link from '@mui/material/Link';
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { LayoutState, PicDimH, PicDimW, PicWidth, ScrollToPosition } from "../Layout";
import { ui } from "../i18n";
import { ImageDesc } from "./GalleryData";

type Lang = "de" | "en";

const landscape = "landscape";
const portrait = "portrait";

const size = PicWidth;
const wh = size * PicDimW / PicDimH;

// The behavior of the component is controlled by two elements:
//     paintingName: name of the painting shown ("" = no painting)
//     params.serie: name of the series shown ("all" = summary of series)
export default function GalleryDesktop(params: {nrRowsPortrait: number, layoutState: LayoutState, serie: string | undefined, lang: string, paintingName: string, heading: string, fullsize: boolean, itemData: ImageDesc[]}) {
    const layoutState = params.layoutState;
    const navigate = useNavigate();
    
    const isNotAll = (params.serie !== "all");
    const crumbColor = isNotAll ? "#b7979c" : "black";

    // Init running row index and number of columns in current row
    let rowIdx = 1;
    let currentCols = 0;

    return (
        <Box>
            <Box sx={{ maxWidth: layoutState.GalleryMaxWidth(), paddingTop: layoutState.GalleryPaddingTop(), paddingLeft: layoutState.GalleryPaddingLeft(), paddingBottom: "10px" }}>
                <Breadcrumbs separator="›">
                    {isNotAll &&
                        <Box>
                            <Link component={RouterLink as any} to="/gallery/all" underline="none" color="inherit" href="/">
                                <Typography variant="body2" sx={{ fontSize: "0.925rem", color: "black" }}>
                                    {ui[params.lang].Gallery.cycles}
                                </Typography>
                            </Link>
                        </Box>
                    }
                    <Typography variant="body2" sx={{ fontSize: "0.925rem", color: crumbColor }}>
                        {params.heading}
                    </Typography>
                </Breadcrumbs>
            </Box>

            <Box sx={{ width: layoutState.GalleryWidth(), marginTop: "16px" }}>
                <ImageList rowHeight={layoutState.fscale() * 550} key={Math.floor(Math.random() * 1000)} sx={{ width: "100%", padding: layoutState.GalleryPaddingImageList(), margin: 0 }} cols={15} gap={layoutState.scale() * 45} >
                    {params.itemData.map((item, idx) => {
                        let w = (item.format === portrait) ? wh : size;
                        const h = (item.format === portrait) ? size : wh;
                        let title = item.title[params.lang as Lang];

                        let cols = (item.format === portrait) ? 5 : 7;
                        if (currentCols + cols > 15) {
                            currentCols = cols;
                            rowIdx++;
                        }
                        else {
                            currentCols += cols;
                        }
                        const ytrans = (rowIdx <= params.nrRowsPortrait + 1) ? 0 : (rowIdx - params.nrRowsPortrait - 1) * 150 * layoutState.scale();

                        return (
                            <ImageListItem cols={cols} key={item.name} sx={{ transform: "translate(0px,-" + ytrans + "px)" }}>
                                <img
                                    src={"/img/" + item.image + ".jpg" + "?versionNr=" + item.versionNr}
                                    loading="lazy"
                                    style={{ maxWidth: layoutState.scale() * w, maxHeight: layoutState.scale() * h, margin: "0", cursor: "pointer", boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)", marginBottom: "0px" }}
                                    onClick={() => {
                                        if (params.serie === "all") {
                                            navigate("/gallery/" + item.name);
                                        }
                                        else {
                                            ScrollToPosition("painting");
                                            navigate("/paintings/" + item.name);
                                        }
                                    }}
                                />
                                <ImageListItemBar position="below" sx={{ marginLeft: "0%", alignItems: "center", paddingTop: (10 * layoutState.scale()) + "px", paddingBottom: "0px", textAlign: "center", maxWidth: "100%", background: "inherit" }}
                                    title={title}
                                />
                            </ImageListItem>
                        )
                    }
                    )}
                </ImageList>
            </Box>
        </Box>
    );
}


